/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubjectType = 'OFO' | 'FO' | 'OPO' | 'PO' | 'SJM' | 'BSM';

export const SubjectType = {
    OFO: 'OFO' as SubjectType,
    FO: 'FO' as SubjectType,
    OPO: 'OPO' as SubjectType,
    PO: 'PO' as SubjectType,
    SJM: 'SJM' as SubjectType,
    BSM: 'BSM' as SubjectType
};

